import { FormControl, InputLabel, MenuItem } from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { ICell } from "../types";
import { ReactElement } from "react";

interface ITopPanelProps  {
  updateCharConfig: (field: string, value: any) => void;
  editableCell: ICell;
}

const TopPanel = ({ editableCell, updateCharConfig }: ITopPanelProps): ReactElement =>  {

  return (
    <div className="display-flex-row">
      <FormControl sx={{ margin: 1, minWidth: 134, width: 134 }}>
        <InputLabel sx={{ transform: "translate(0px, 0px) scale(0.75) !important" }}>Filter Top</InputLabel>
        <Select
          variant="standard"
          value={editableCell.top ?? 0}
          displayEmpty={true}
          onChange={(event: SelectChangeEvent<number>) => updateCharConfig("top", event.target.value)}>
          <MenuItem value={0}>None</MenuItem>
          <MenuItem value={3}>3</MenuItem>
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
        </Select>
      </FormControl>

      <FormControl sx={{ margin: 1, minWidth: 134, width: 134 }}>
        <InputLabel sx={{ transform: "translate(0px, 0px) scale(0.75) !important" }}>Filter By</InputLabel>
        <Select
          variant="standard"
          value={editableCell.filterBy ?? "DIMENSION"}
          displayEmpty={true}
          disabled={!(editableCell.top ?? 0)}
          onChange={(event: SelectChangeEvent) => updateCharConfig("filterBy", event.target.value)}>
          <MenuItem value={"DIMENSION"}>Dimension</MenuItem>
          <MenuItem value={"SERIES"}>Series</MenuItem>
        </Select>
      </FormControl>


      <FormControl sx={{ margin: 1, minWidth: 134, width: 134 }}>
        <InputLabel sx={{ transform: "translate(0px, 0px) scale(0.75) !important" }}>Order</InputLabel>
        <Select
          variant="standard"
          value={editableCell.orderAsc ? "ASC" : "DESC"}
          displayEmpty={true}
          disabled={!(editableCell.top ?? 0)}
          onChange={(event: SelectChangeEvent) => updateCharConfig("orderAsc", event.target.value === "ASC")}>
          <MenuItem value={"ASC"}>ASC</MenuItem>
          <MenuItem value={"DESC"}>DESC</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

export default TopPanel;
